const items = {
  28: {
    success: true,
    ID: 28,
    title: "Nose Bleeds",
    description: "",
    type: 1,
    totalSlots: 20,
    slotsTaken: 4,
    maxSingleUserSlots: 4,
    showRespondentsCount: false,
    orderNumber: 0,
    fundIt: {
      hasSignupCost: true,
      cost: {
        // This is only here if costType = PerSignup
        costType: "PerItem",
        amounts: [
          {
            numberOfSlots: 1,
            amount: 10000,
            id: 1,
          },
          {
            numberOfSlots: 4,
            amount: 12500,
            id: 2,
          },
        ],
      },
    },
    respondents: [
      {
        isHousehold: true,
        householdTitle: "The User Household",
        householdID: 3,
        numberOfSlots: 2,
        householdRespondents: [
          {
            additionalNameID: 69,
            fname: "Regular",
            lname: "User",
            // paymentStatus: null,
            // paymentAmount: null,
            // paymentDate: null,
            // payerName: null,
            paymentStatus: "Paid",
            markedPaidRecorderName: null,
            paymentAmount: 2500,
            paymentDate: "2022-12-01",
            payerName: "Regular User",
            userID: 5,
            name: "Regular User",
            numberOfSlots: 2,
            userSignupHistory: [
              {
                signupListItem: {
                  ID: 28,
                  title: "Nose Bleeds",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671653287,
                    dateString: "Dec 21 at 3:08 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "7QHS",
                  signedUpViaIcon: "faUsersMedical",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Regular",
                        lname: "User",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
            userSignupID: 33,
            householdID: 3,
          },
          {
            additionalNameID: 76,
            fname: "My",
            lname: "Guest",
            // paymentStatus: null,
            // paymentAmount: null,
            // paymentDate: null,
            // payerName: null,
            paymentAmount: 2000,
            paymentStatus: "Paid",
            paymentDate: "2022-12-15",
            payerName: "Regular User",
            markedPaidRecorderName: null,
            isAdditionalName: true,
          },
        ],
      },
    ],
    cancelledRespondents: [
      {
        userID: 2,
        name: "Super Admin",
        fname: "Super",
        userSignupHistory: [
          {
            signupListItem: {
              ID: 28,
              title: "Nose Bleeds",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671653924,
                dateString: "Dec 21 at 3:18 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "2KCR",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
          {
            signupListItem: {
              ID: 28,
              title: "Nose Bleeds",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671654127,
                dateString: "Dec 21 at 3:22 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "F9F6",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
          {
            signupListItem: {
              ID: 28,
              title: "Nose Bleeds",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671654375,
                dateString: "Dec 21 at 3:26 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "8XS6",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
          {
            signupListItem: {
              ID: 28,
              title: "Nose Bleeds",
            },
            event: {
              ID: 4,
              created: {
                timestamp: 1671654414,
                dateString: "Dec 21 at 3:26 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "8XS6",
              signedUpViaIcon: "faExternalLink",
              details: {
                switchedToItemID: null,
              },
            },
          },
          {
            signupListItem: {
              ID: 30,
              title: "50 Yard Line",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671744655,
                dateString: "Dec 22 at 4:30 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "HL3Q",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 2,
                additionalNames: [
                  {
                    fname: "Tink",
                    lname: "Wing",
                  },
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
        ],
      },
    ],
    extendedFields: [
      {
        type: "picker",
        icon: "info-circle fas far",
        multiSelect: true,
        options: [
          {
            ID: 10,
            title: "First Option",
          },
          {
            ID: 11,
            title: "Second Option",
          },
          {
            ID: 12,
            title: "Third Option",
          },
        ],
        title: "multiSelect Test",
        fieldID: 41,
        inputIsRequired: false,
        entityType: "user",
      },
      {
        type: "date",
        icon: "info-circle fas far",
        includeYear: false,
        title: "NoYear",
        fieldID: 87,
        inputIsRequired: false,
        entityType: "user",
      },
      {
        type: "address",
        icon: "map-marker-alt fas",
        defaultCountryID: 1,
        allowChangeCountry: true,
        title: "Address",
        fieldID: 5,
        inputIsRequired: false,
        entityType: "user",
      },
    ],
    // fieldsOnItem: [
    //   {
    //     title: "multiSelect Test",
    //     icon: "info-circle fas far",
    //     configuration: {
    //       behaviorOptions: {
    //         allowMultiple: true,
    //       },
    //       responseOptions: {
    //         optionsType: "responseOptionList",
    //         responseOptionList: [
    //           {
    //             optionListValueID: 10,
    //             optionListValue: "First Option",
    //           },
    //           {
    //             optionListValueID: 11,
    //             optionListValue: "Second Option",
    //           },
    //           {
    //             optionListValueID: 12,
    //             optionListValue: "Third Option",
    //           },
    //         ],
    //       },
    //     },
    //     visibility: "private",
    //     networkFieldID: 41,
    //     createdByID: 64,
    //     fieldTypeID: 5,
    //     fieldTypeInstanceID: 31,
    //     fieldResponseEditPermissionID: 1,
    //     fieldResponseViewPermissionID: 1,
    //     fieldResponseOptionListID: 3,
    //     fieldResponseEntity: "user",
    //     blockSharing: false,
    //     required: false,
    //     fromProfile: true,
    //   },
    //   {
    //     title: "NoYear",
    //     icon: "info-circle fas far",
    //     configuration: {
    //       subfields: {
    //         year: {
    //           isVisible: "0",
    //         },
    //       },
    //     },
    //     visibility: "private",
    //     networkFieldID: 87,
    //     createdByID: 2,
    //     fieldTypeID: 2,
    //     fieldTypeInstanceID: 56,
    //     fieldResponseEditPermissionID: 1,
    //     fieldResponseViewPermissionID: 1,
    //     fieldResponseOptionListID: null,
    //     fieldResponseEntity: "user",
    //     blockSharing: false,
    //     required: false,
    //     fromProfile: true,
    //   },
    //   {
    //     title: "Address",
    //     icon: "map-marker-alt fas",
    //     configuration: {
    //       type: "address",
    //       subfields: {
    //         addr1: {
    //           isVisible: true,
    //         },
    //         addr2: {
    //           isVisible: false,
    //         },
    //         city: {
    //           isVisible: true,
    //         },
    //         state: {
    //           isVisible: true,
    //         },
    //         zip: {
    //           isVisible: true,
    //         },
    //         country: {
    //           isVisible: true,
    //         },
    //       },
    //       responseOptions: {
    //         default: {
    //           city: "",
    //           state: "",
    //           country: "US",
    //         },
    //       },
    //     },
    //     visibility: "default",
    //     networkFieldID: 5,
    //     createdByID: 2,
    //     fieldTypeID: 4,
    //     fieldTypeInstanceID: 5,
    //     fieldResponseEditPermissionID: 1,
    //     fieldResponseViewPermissionID: 1,
    //     fieldResponseOptionListID: null,
    //     fieldResponseEntity: "user",
    //     blockSharing: false,
    //     required: false,
    //     fromProfile: true,
    //   },
    // ],
  },
  29: {
    success: true,
    ID: 29,
    title: "Club Level",
    description: "",
    type: 1,
    totalSlots: 20,
    slotsTaken: 3,
    maxSingleUserSlots: 4,
    orderNumber: 1,
    fundIt: {
      hasSignupCost: true,
      cost: {
        // This is only here if costType = PerSignup
        costType: "PerItem",
        amounts: [
          {
            numberOfSlots: null,
            amount: 900,
            id: 1,
          },
        ],
      },
    },
    fundName: "Signup - All New Test Event",
    respondents: [
      {
        isHousehold: true,
        householdTitle: "The User Household",
        householdID: 4,
        numberOfSlots: 1,
        householdRespondents: [
          {
            additionalNameID: 73,
            fname: "Other",
            lname: "User",
            paymentStatus: "MarkedAsPaid",
            paymentDate: "2022-12-01",
            paymentAmount: "500",
            payerName: "Regular User",
            markedPaidRecorderName: "the Cat in the Hat",
            userID: 6,
            name: "Other User",
            numberOfSlots: 1,
            userSignupHistory: [
              {
                signupListItem: {
                  ID: 29,
                  title: "Club Level",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671744320,
                    dateString: "Dec 22 at 4:25 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "2358",
                  signedUpViaIcon: "faUsersMedical",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Other",
                        lname: "User",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
            userSignupID: 37,
            householdID: 4,
          },
        ],
      },
      {
        additionalNameID: 79,
        fname: "Some NonHousehold",
        lname: "Person",
        paymentStatus: "Paid",
        markedPaidRecorderName: null,
        paymentDate: "2022-12-01",
        paymentAmount: "500",
        payerName: "Some NonHousehold Person",
        userID: 45,
        name: "Some NonHousehold Person",
        numberOfSlots: 1,
        userSignupHistory: [
          {
            signupListItem: {
              ID: 35,
              title: "Sec 2",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1673539499,
                dateString: "Jan 12 at 11:04 AM",
                userInfo: {
                  ID: 45,
                  fname: "Some NonHousehold",
                  lname: "Person",
                },
              },
              confirmationNumber: "S2G7",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Some NonHousehold",
                    lname: "Person",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
        ],
        userSignupID: 41,
        householdID: 0,
      },
      {
        additionalNameID: 79,
        fname: "Some UNPAID",
        lname: "Person",
        paymentStatus: "UnPaid",
        markedPaidRecorderName: null,
        paymentDate: "2022-12-01",
        paymentAmount: null,
        payerName: null,
        userID: 49,
        name: "Some NonHousehold Person",
        numberOfSlots: 1,
        userSignupHistory: [
          {
            signupListItem: {
              ID: 35,
              title: "Sec 2",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1673539499,
                dateString: "Jan 12 at 11:04 AM",
                userInfo: {
                  ID: 45,
                  fname: "Some NonHousehold",
                  lname: "Person",
                },
              },
              confirmationNumber: "S2G7",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Some NonHousehold",
                    lname: "Person",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
        ],
        userSignupID: 41,
        householdID: 0,
      },
    ],
    cancelledRespondents: [
      {
        userID: 2,
        name: "Super Admin",
        fname: "Super",
        userSignupHistory: [
          {
            signupListItem: {
              ID: 29,
              title: "Club Level",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671654051,
                dateString: "Dec 21 at 3:20 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "2KCR",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
          {
            signupListItem: {
              ID: 29,
              title: "Club Level",
            },
            event: {
              ID: 4,
              created: {
                timestamp: 1671654114,
                dateString: "Dec 21 at 3:21 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "QZQV",
              signedUpViaIcon: "faExternalLink",
              details: {
                switchedToItemID: null,
              },
            },
          },
          {
            signupListItem: {
              ID: 29,
              title: "Club Level",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671654135,
                dateString: "Dec 21 at 3:22 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "F9F6",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 1,
                additionalNames: [
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
          {
            signupListItem: {
              ID: 29,
              title: "Club Level",
            },
            event: {
              ID: 2,
              created: {
                timestamp: 1671654284,
                dateString: "Dec 21 at 3:24 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "7SKV",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: {
                  before: 0,
                  after: 0,
                },
                additionalNames: {
                  before: [],
                  after: [],
                  added: [],
                  removed: [],
                  autoDeleted: [],
                },
              },
            },
          },
          {
            signupListItem: {
              ID: 29,
              title: "Club Level",
            },
            event: {
              ID: 4,
              created: {
                timestamp: 1671654292,
                dateString: "Dec 21 at 3:24 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "T3JI",
              signedUpViaIcon: "faExternalLink",
              details: {
                switchedToItemID: null,
              },
            },
          },
          {
            signupListItem: {
              ID: 30,
              title: "50 Yard Line",
            },
            event: {
              ID: 1,
              created: {
                timestamp: 1671744655,
                dateString: "Dec 22 at 4:30 PM",
                userInfo: {
                  ID: 2,
                  fname: "Super",
                  lname: "Admin",
                },
              },
              confirmationNumber: "HL3Q",
              signedUpViaIcon: "faExternalLink",
              details: {
                slots: 2,
                additionalNames: [
                  {
                    fname: "Tink",
                    lname: "Wing",
                  },
                  {
                    fname: "Super",
                    lname: "Admin",
                    isUserWhoSignedUp: true,
                  },
                ],
              },
            },
          },
        ],
      },
    ],
    extendedFields: [],
    // fieldsOnItem: [],
  },
  30: {
    success: true,
    ID: 30,
    title: "50 Yard Line",
    description: "",
    type: 1,
    totalSlots: 17,
    slotsTaken: 2,
    maxSingleUserSlots: 4,
    orderNumber: 2,
    fundIt: {
      hasSignupCost: true,
      cost: {
        // This is only here if costType = PerSignup
        costType: "PerSlot",
        amounts: [
          {
            numberOfSlots: 1,
            amount: 5000,
            id: 1,
          },
          {
            numberOfSlots: 3,
            amount: 10000,
            id: 2,
          },
        ],
      },
    },
    fundName: "General",
    respondents: [
      {
        isHousehold: true,
        householdTitle: "The Admin Household",
        householdID: 1,
        numberOfSlots: 2,
        householdRespondents: [
          {
            additionalNameID: 74,
            fname: "Tink",
            lname: "Wing",
            paymentStatus: null,
            markedPaidRecorderName: null,
            paymentAmount: null,
            paymentDate: null,
            payerName: null,
            isAdditionalName: true,
          },
          {
            additionalNameID: 75,
            fname: "Super",
            lname: "Admin",
            paymentStatus: null,
            markedPaidRecorderName: null,
            paymentAmount: null,
            paymentDate: null,
            payerName: null,
            userID: 2,
            name: "Super Admin",
            numberOfSlots: 2,
            userSignupHistory: [
              {
                signupListItem: {
                  ID: 30,
                  title: "50 Yard Line",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671744655,
                    dateString: "Dec 22 at 4:30 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "HL3Q",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 2,
                    additionalNames: [
                      {
                        fname: "Tink",
                        lname: "Wing",
                      },
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
            userSignupID: 38,
            householdID: 1,
          },
        ],
      },
    ],
    cancelledRespondents: [],
    extendedFields: [
      {
        type: "picker",
        icon: "info-circle fas far",
        multiSelect: true,
        options: [
          {
            ID: 10,
            title: "First Option",
          },
          {
            ID: 11,
            title: "Second Option",
          },
          {
            ID: 12,
            title: "Third Option",
          },
        ],
        title: "multiSelect Test",
        fieldID: 41,
        inputIsRequired: false,
        entityType: "user",
      },
      {
        type: "date",
        icon: "info-circle fas far",
        includeYear: false,
        title: "NoYear",
        fieldID: 87,
        inputIsRequired: false,
        entityType: "user",
      },
      {
        type: "address",
        icon: "map-marker-alt fas",
        defaultCountryID: 1,
        allowChangeCountry: true,
        title: "Address",
        fieldID: 5,
        inputIsRequired: false,
        entityType: "user",
      },
    ],
    // fieldsOnItem: [
    //   {
    //     title: "multiSelect Test",
    //     icon: "info-circle fas far",
    //     configuration: {
    //       behaviorOptions: {
    //         allowMultiple: true,
    //       },
    //       responseOptions: {
    //         optionsType: "responseOptionList",
    //         responseOptionList: [
    //           {
    //             optionListValueID: 10,
    //             optionListValue: "First Option",
    //           },
    //           {
    //             optionListValueID: 11,
    //             optionListValue: "Second Option",
    //           },
    //           {
    //             optionListValueID: 12,
    //             optionListValue: "Third Option",
    //           },
    //         ],
    //       },
    //     },
    //     visibility: "private",
    //     networkFieldID: 41,
    //     createdByID: 64,
    //     fieldTypeID: 5,
    //     fieldTypeInstanceID: 31,
    //     fieldResponseEditPermissionID: 1,
    //     fieldResponseViewPermissionID: 1,
    //     fieldResponseOptionListID: 3,
    //     fieldResponseEntity: "user",
    //     blockSharing: false,
    //     required: false,
    //     fromProfile: true,
    //   },
    //   {
    //     title: "NoYear",
    //     icon: "info-circle fas far",
    //     configuration: {
    //       subfields: {
    //         year: {
    //           isVisible: "0",
    //         },
    //       },
    //     },
    //     visibility: "private",
    //     networkFieldID: 87,
    //     createdByID: 2,
    //     fieldTypeID: 2,
    //     fieldTypeInstanceID: 56,
    //     fieldResponseEditPermissionID: 1,
    //     fieldResponseViewPermissionID: 1,
    //     fieldResponseOptionListID: null,
    //     fieldResponseEntity: "user",
    //     blockSharing: false,
    //     required: false,
    //     fromProfile: true,
    //   },
    //   {
    //     title: "Address",
    //     icon: "map-marker-alt fas",
    //     configuration: {
    //       type: "address",
    //       subfields: {
    //         addr1: {
    //           isVisible: true,
    //         },
    //         addr2: {
    //           isVisible: false,
    //         },
    //         city: {
    //           isVisible: true,
    //         },
    //         state: {
    //           isVisible: true,
    //         },
    //         zip: {
    //           isVisible: true,
    //         },
    //         country: {
    //           isVisible: true,
    //         },
    //       },
    //       responseOptions: {
    //         default: {
    //           city: "",
    //           state: "",
    //           country: "US",
    //         },
    //       },
    //     },
    //     visibility: "default",
    //     networkFieldID: 5,
    //     createdByID: 2,
    //     fieldTypeID: 4,
    //     fieldTypeInstanceID: 5,
    //     fieldResponseEditPermissionID: 1,
    //     fieldResponseViewPermissionID: 1,
    //     fieldResponseOptionListID: null,
    //     fieldResponseEntity: "user",
    //     blockSharing: false,
    //     required: false,
    //     fromProfile: true,
    //   },
    // ],
  },
};

/**
 * @type {function}
 * @param {number} postData.signupListItemID
 */
const mockViewItem = ({ signupListItemID }) => items[signupListItemID];

export default mockViewItem;
